if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      //this.cart = document.querySelector('cart-notification:not(.ab-test-disabled)') || document.querySelector('cart-drawer');
      this.additionalProductIds = (this.dataset.additionalProducts && this.dataset.additionalProducts.split(',')) || []
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if(!this.cart){
        this.cart = document.querySelector('cart-notification:not(.ab-test-disabled)') || document.querySelector('cart-drawer');
      }
        
      const submitButtons = this.querySelectorAll('[type="submit"]');
      if (Array.from(submitButtons).find(submittButton => submittButton.classList.contains('loading'))) return;

      this.handleErrorMessage();
      this.cart?.setActiveElement(document.activeElement);

      submitButtons.forEach(submittButton => submittButton.setAttribute('aria-disabled', true));
      submitButtons.forEach(submittButton => submittButton.classList.add('loading'));
      this.querySelectorAll('.loading-overlay__spinner').forEach(loadingSpinner => loadingSpinner.classList.remove('hidden'));

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';

      const sections = this.cart?.getSectionsToRender().map((section) => section.id);
      const sections_url = window.location.pathname;
      const formData = new FormData(this.form);
      const body = {
        items: [
          {id: formData.get('id'), quantity: formData.get('quantity') || 1}
        ],
        sections,
        sections_url,
      }
      this.additionalProductIds.forEach(productId => body.items.push({
        id: productId, quantity: 1
      }))
      config.body = JSON.stringify(body);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach(submittButton => submittButton.classList.remove('loading'));
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty')
          submitButtons.forEach(submittButton => submittButton.removeAttribute('aria-disabled'));
          this.querySelectorAll('.loading-overlay__spinner').forEach(loadingSpinner => loadingSpinner.classList.add('hidden'));
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
